module.exports = __webpack_public_path__ + "static/media/credit-review-free-trial-invitation.5db4edbf.jpg";